<template>
  <div>
    <div class="dialog-container"
         v-show="showGenericDialog">
      <div class="dialog-container-content">
        <div class="col-11 col-md-8 col-lg-7 center-dialog no-gutters">

          <div class="alert-dialog">
            <div class="">
              <div class="close-container">
                <a class=" " v-if="showCloseButton"
                   v-on:click="close()"><i class="fas fa-times"></i><span>Close</span></a>
              </div>
              <div class="title"
                   v-if="this.title !== null && this.title.length > 0">
                <h3>{{this.title}}</h3>
              </div>
              <div class="body">
                <div class="body-content">
                  <div v-html="this.content"></div>
                  <slot></slot>
                </div>
              </div>
            </div>
            <div class="form-group  ">
              <div class="col-12 ">
                <div class=" text-center">
                  <div class="dialog-buttons">

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import currencyFilter from "@/filters/currencyFilter";
export default {
  name: "GenericDialog",
  props: {
    showGenericDialog: {
      type: Boolean,
      default: () => false
    },
    showCloseButton: {
      type: Boolean,
      default: () => false
    },
    title: { type: String, default: () => "" },
    content: { required: true, type: String, default: () => "" }
  },
  filters: { currencyFilter },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    close() {
      this.$emit("close", "", {});
      //this.$emit("update", selectedOption, {});
    },
  }
};
</script>

<style scoped>
h2 {
  padding-top: 10px;
  padding-bottom: 10px;
  font-weight: 400;
}
.alert-dialog {
  background: #ffffff;
  margin-top: 20px;
  margin-bottom: 20px;
  padding-bottom: 10px;
  text-align: left;
  border-radius: 1.5em;
}
.alert-dialog-buttons {
  display: flex;
  justify-content: center;
}
.dialog-btn {
  align-self: center;
  padding-left: 8px;
  padding-right: 8px;
  margin: 10px 8px;
  width: 110px;
}
.title {
  text-align: left;
}
.title h3 {
  padding: 10px 0 5px 20px;
  color: #1a2857;
}
.body {
  /*border-top: 1px solid #c1c1c1;
  border-bottom: 1px solid #c1c1c1;*/
  padding-top: 5px;
  padding-bottom: 5px;
  margin-bottom: 5px;
  margin-top: 5px;
  background: #ffffff;
}
.body-content {
  padding: 5px 20px;
  color: #1a2857;
}
/* .amount {
  padding-top: 12px;
} */
.addon-btn {
  width: 130px;
}
.body-content p {
  padding-bottom: 5px;
}
.body-content a {
  text-decoration: underline;
  cursor: pointer;
}
.close-container {
  text-align: right;
  padding: 10px 20px;
  color: #1a2857;
  font-size: 1.5rem;
  cursor: pointer;
}
.close-container a {
  text-decoration: none;
}
.close-container a:hover {
  color: #f76631;
}

.close-container i {
  font-weight: 600;
  padding-right: 10px;
}
</style>